import type { FC } from 'react';
import { useState, Fragment } from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Collapse,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { numberToMillons } from 'src/utils/functions';

const SeguimientoOficinaDetailRow: FC<{ item: any; level: number }> = ({
  item,
  level,
}) => {
  const [open, setOpen] = useState(item.detail?.open);
  const keyDetailHead = `detail-fuvex-h-${item.id}`;
  const tabSpacing = `${(level - 1) * 15}px`;

  return (
    <Fragment key={item.id}>
      <TableRow>
        <TableCell align="left" width={500} style={{ paddingLeft: tabSpacing }}>
          {item.detail && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
          {item.label}
        </TableCell>
        <TableCell align="right" width={150}>
          {item.operaciones}
        </TableCell>
        <TableCell align="right" width={150}>
          {numberToMillons(item.facturacion)}
        </TableCell>
        <TableCell align="right" width={100}>
          {item.meta && numberToMillons(item.meta)}
        </TableCell>
        <TableCell align="right" width={100}>
          {item.aporte}
          {item.aporte ? '%' : ''}
        </TableCell>
      </TableRow>
      {item.detail && (
        <>
          <TableRow key={keyDetailHead}>
            <TableCell
              colSpan={7}
              style={{ display: open ? 'table-cell' : 'none', padding: 0 }}
            >
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Table size="small" style={{ background: 'white' }}>
                  <TableBody>
                    {item.detail?.data?.map((detail, index) => {
                      const key = `rowDetaill-l${level + 1}-${index}`;
                      return (
                        <SeguimientoOficinaDetailRow
                          key={key}
                          item={detail}
                          level={level + 1}
                        />
                      );
                    })}
                  </TableBody>
                </Table>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      )}
    </Fragment>
  );
};

export default SeguimientoOficinaDetailRow;
